/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Platforms_Listing_Empty_DescriptionInputs */

const en_directory_platforms_listing_empty_description = /** @type {(inputs: Directory_Platforms_Listing_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse the full directory or submit a product with its platform details.`)
};

const zh_directory_platforms_listing_empty_description = /** @type {(inputs: Directory_Platforms_Listing_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览完整目录，或提交产品并补充它的平台信息。`)
};

/**
* | output |
* | --- |
* | "Browse the full directory or submit a product with its platform details." |
*
* @param {Directory_Platforms_Listing_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_listing_empty_description = /** @type {((inputs?: Directory_Platforms_Listing_Empty_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_Listing_Empty_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_listing_empty_description(inputs)
	return zh_directory_platforms_listing_empty_description(inputs)
});
export { directory_platforms_listing_empty_description as "directory.platforms.listing_empty_description" }